package ru.villawonka.app.platform

import kotlinx.browser.window
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import ru.villawonka.app.platform.telegram.Telegram
import ru.villawonka.app.platform.telegram.model.SafeAreaInset
import ru.villawonka.app.platform.telegram.model.WebAppInitData

@OptIn(DelicateCoroutinesApi::class)
class JsTelegram : Telegram {

    private val json = Json { ignoreUnknownKeys = true }

    override val eventHandlerFlow: MutableSharedFlow<Telegram.Event> = MutableSharedFlow()

    override fun getInitDataUnsafe(): WebAppInitData {
        val initDataUnsafeJson = JSON.stringify(window.asDynamic().Telegram.WebApp.initDataUnsafe)
        return json.decodeFromString<WebAppInitData>(initDataUnsafeJson)
    }

    override fun getInitData(): String = window.asDynamic().Telegram.WebApp.initData as String

    override fun isAppleDevice(): Boolean {
        return js("/iPad|iPhone|iPod/.test(navigator.platform)") as Boolean
    }

    override fun showAlert(text: String) {
        window.asDynamic().Telegram.WebApp.showAlert(text)
    }

    override fun openLink(url: String) {
        window.asDynamic().Telegram.WebApp.openLink(url)

    }

    override fun openTelegramLink(url: String) {
        window.asDynamic().Telegram.WebApp.openTelegramLink(url)
    }

    override fun openWindowLink(url: String) {
        window.open(url, "_blanc")
    }

    override fun ready() {
        window.asDynamic().Telegram.WebApp.ready()
    }

    override fun expand() {
        window.asDynamic().Telegram.WebApp.expand()
    }

    override fun close() {
        window.asDynamic().Telegram.WebApp.close()
    }

    override fun enableVerticalSwipes() {
        window.asDynamic().Telegram.WebApp.enableVerticalSwipes()
    }

    override fun disableVerticalSwipes() {
        window.asDynamic().Telegram.WebApp.disableVerticalSwipes()
    }

    override fun enableClosingConfirmation() {
        window.asDynamic().Telegram.WebApp.enableClosingConfirmation()
    }

    override fun disableClosingConfirmation() {
        window.asDynamic().Telegram.WebApp.disableClosingConfirmation()
    }

    override fun lockOrientation() {
        window.asDynamic().Telegram.WebApp.lockOrientation()
    }

    override fun unlockOrientation() {
        window.asDynamic().Telegram.WebApp.unlockOrientation()
    }

    override fun setHeaderColor(hex: String) {
        window.asDynamic().Telegram.WebApp.setHeaderColor(hex)

    }

    override fun setBackgroundColor(hex: String) {
        window.asDynamic().Telegram.WebApp.setBackgroundColor(hex)
    }

    override fun setBottomBarColor(hex: String) {
        window.asDynamic().Telegram.WebApp.setBottomBarColor(hex)
    }


    override fun setBackButtonVisible(isVisible: Boolean) {
        if (isVisible) {
            window.asDynamic().Telegram.WebApp.BackButton.show()
        } else {
            window.asDynamic().Telegram.WebApp.BackButton.hide()
        }
    }

    override fun setSettingsButtonVisible(isVisible: Boolean) {
        if (isVisible) {
            window.asDynamic().Telegram.WebApp.SettingsButton.show()
        } else {
            window.asDynamic().Telegram.WebApp.SettingsButton.hide()
        }
    }

    override fun getSafeAreaInset(): SafeAreaInset {
        val safeAreaInset = JSON.stringify(window.asDynamic().Telegram.WebApp.safeAreaInset)
        return json.decodeFromString<SafeAreaInset>(safeAreaInset)
    }

    override fun requestFullscreen() {
        window.asDynamic().Telegram.WebApp.requestFullscreen()
    }

    override fun exitFullscreen() {
        window.asDynamic().Telegram.WebApp.exitFullscreen()
    }


    override fun registerEventListener(event: Telegram.Event) {
        when (event) {
            Telegram.Event.OnBackButtonClicked ->
                window.asDynamic().window.Telegram.WebApp.BackButton.onClick({
                    GlobalScope.launch {
                        eventHandlerFlow.emit(Telegram.Event.OnBackButtonClicked)
                    }
                })

            Telegram.Event.OnSettingsButtonClicked ->
                window.asDynamic().window.Telegram.WebApp.SettingsButton.onClick({
                    GlobalScope.launch {
                        eventHandlerFlow.emit(Telegram.Event.OnSettingsButtonClicked)
                    }
                })
        }
    }
}